import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=8e5d1c5a&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d1c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e5d1c5a')) {
      api.createRecord('8e5d1c5a', component.options)
    } else {
      api.reload('8e5d1c5a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=8e5d1c5a&scoped=true", function () {
      api.rerender('8e5d1c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/bodyclass/edit.vue"
export default component.exports